import { AfterViewInit, Directive, ElementRef, inject, input, Renderer2 } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[accredibleShowMore]',
})
export class ShowMoreDirective implements AfterViewInit {
  private readonly _el = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);

  maxLength = input<number>(100);

  readMore = input<string>('read more');
  readLess = input<string>('read less');

  private _isExpanded = false;
  private _fullText: string = '';
  private _truncatedText: string = '';
  private _textSpan!: HTMLElement;
  private _toggleLink!: HTMLElement;

  ngAfterViewInit(): void {
    this._fullText = this._el.nativeElement.textContent.trim();
    if (this._fullText.length <= this.maxLength()) return;

    this._truncatedText = this._fullText.slice(0, this.maxLength()) + '...';

    // Clear original text
    this._renderer.setProperty(this._el.nativeElement, 'textContent', '');

    // Create span for text
    this._textSpan = this._renderer.createElement('span');
    this._renderer.setProperty(this._textSpan, 'textContent', this._truncatedText);
    this._renderer.appendChild(this._el.nativeElement, this._textSpan);

    // Create toggle link
    this._toggleLink = this._renderer.createElement('a');
    this._renderer.setProperty(this._toggleLink, 'textContent', ` ${this.readMore()}`);
    this._renderer.setStyle(this._toggleLink, 'color', 'var(--color-natural-180)');
    this._renderer.setStyle(this._toggleLink, 'cursor', 'pointer');
    this._renderer.listen(this._toggleLink, 'click', (event) => this.toggle(event));
    this._renderer.appendChild(this._el.nativeElement, this._toggleLink);
  }

  private toggle(event: Event): void {
    this._isExpanded = !this._isExpanded;
    this._renderer.setProperty(
      this._textSpan,
      'textContent',
      this._isExpanded ? this._fullText : this._truncatedText,
    );
    this._renderer.setProperty(
      this._toggleLink,
      'textContent',
      this._isExpanded ? ` ${this.readLess()}` : ` ${this.readMore()}`,
    );
    event.preventDefault();
  }
}
